// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyNotifications_container__iHwjD","title":"CompanyNotifications_title__3CqSM"};